import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ButtonIconSet, ButtonIconType } from '../buttons.types';

@Component({
  selector: 'common-text-button',
  templateUrl: './text-button.component.html',
  styleUrls: ['./text-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TextButtonComponent implements OnInit {
  private readonly defaultIconSet = 'material-symbols-rounded';

  /** Color semantic del botón de texto. */
  @Input() color: 'default' | 'warning' = 'default';

  @Input() label: string;
  /** Si se define, reemplaza el texto accesible (p. ej. etiqueta corta + descripción larga). */
  @Input() ariaLabel: string;
  @Input() icon: string;
  @Input() disabled: boolean = false;
  @Input() typeIcon: ButtonIconType;
  @Input() iconSet: ButtonIconSet;
  @Input() iconPosition: boolean = true;

  @Output() output = new EventEmitter<boolean>();

  ngOnInit(): void {}

  get iconClass(): string {
    if (this.iconSet) {
      return this.iconSet;
    }

    if (this.typeIcon === 'outlined') {
      return 'material-icons-outlined';
    }

    if (this.typeIcon === 'rounde') {
      return 'material-symbols-rounded';
    }

    return this.defaultIconSet;
  }

  onClick(): void {
    this.output.emit(true);
  }
}
